"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnSelectorOption = exports.ColumnSelectorList = exports.ColumnSelectorButton = exports.ColumnSelector = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ColumnSelector = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n"])));

exports.ColumnSelector = ColumnSelector;

var ColumnSelectorButton = _styledComponents["default"].button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 180px;\n"])));

exports.ColumnSelectorButton = ColumnSelectorButton;

var ColumnSelectorList = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: calc(100% + 5px);\n    right: 0;\n    background-color: #ffffff;\n    min-width: 100%;\n    max-height: 300px;\n    overflow: auto;\n    padding: 5px;\n    box-shadow: 0 0 3px 0px #c5c5c5;\n    border-radius: 4px;\n    z-index: 10;\n"])));

exports.ColumnSelectorList = ColumnSelectorList;

var ColumnSelectorOption = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    label {\n        cursor: pointer;\n        user-select: none;\n        width: 100%;\n    }\n\n    &:last-child {\n        label {\n            margin-bottom: 0;\n        }\n    }\n"])));

exports.ColumnSelectorOption = ColumnSelectorOption;